var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/is-not-undefined.ts
function isNotUndefined(x) {
  return x !== void 0;
}
__name(isNotUndefined, "isNotUndefined");
export {
  isNotUndefined
};
//# sourceMappingURL=index.js.map